import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import {  IPoIncDistribution } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { IRolesDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";

interface IProps{
    singleData: IPoIncDistribution,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema=yup.object({
    role_ID: yup.number().min(1, "Role is required").required("Name is required"),
    inc_Per: yup.number().positive("Inc Per(%) is required").required("% is required")
});

export const Form = (props: IProps) => {
    const [saveDis,setSaveDis] = useState(false);
    const [roles, setRoles] = useState<Array<IRolesDropdown>>();


    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IPoIncDistribution>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit=(data: IPoIncDistribution)=>{
        saveToDB(data);
    }

    const saveToDB = async (data: any) => {
        const method = props.singleData.id != null ? "PUT" : "POST";
        const message = props.singleData.id !=null ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("PO_Incentive_Distribution", method, data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        } 
    }

    const loadRoles = async () => {
        const response = await Fetch("Dropdown/roles", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setRoles(_data);
        }
    }

    const onHide=()=>{
        props.hideDialog();
    }

    useEffect(()=>{
        reset(props.singleData);
    },[props.open]);

    useEffect(() => {
        loadRoles();
    }, []);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Visa" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown required column={4} label="Role" control={control} name="role_ID" options={roles} optionLabel="role_Name" optionValue="role_ID" placeholder="Select Role" error={errors.role_ID?.message} />

                {/* <JVInput required label="Visa Name:" control={control} name="visa_Name" error={errors.visa_Name?.message} /> */}
                <JVInput required label="Inc Per(%)" control={control} name="inc_Per" error={errors.inc_Per?.message} />
                
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" ></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}